import { AnnouncementStyle } from 'api/announcements/models/AnnouncementStyle';

export interface AnnouncementColors {
    textColor: string;
    backgroundColor: string;
    accentColor: string;
}

const PRESET_COLORS: Record<string, AnnouncementColors> = {
    [AnnouncementStyle.SUCCESS]: { textColor: '#0B6B66', backgroundColor: '#D7F6F4', accentColor: '#16CCC3' },
    [AnnouncementStyle.WARNING]: { textColor: '#7A611A', backgroundColor: '#FBF0CF', accentColor: '#E2B434' },
    [AnnouncementStyle.DANGER]: { textColor: '#8F2F2F', backgroundColor: '#F8D7D7', accentColor: '#DC4C4C' },
};

const DEFAULT_CUSTOM: AnnouncementColors = { textColor: '#1F2937', backgroundColor: '#E5E7EB', accentColor: '#1F2937' };

export function resolveAnnouncementColors(
    style: AnnouncementStyle,
    textColor?: string | null,
    backgroundColor?: string | null
): AnnouncementColors {
    if (style === AnnouncementStyle.CUSTOM) {
        return {
            textColor: textColor || DEFAULT_CUSTOM.textColor,
            backgroundColor: backgroundColor || DEFAULT_CUSTOM.backgroundColor,
            accentColor: textColor || DEFAULT_CUSTOM.accentColor,
        };
    }
    return PRESET_COLORS[style] || PRESET_COLORS[AnnouncementStyle.WARNING];
}

// Severity order used to pick the icon color when several announcements are active.
const SEVERITY_ORDER: AnnouncementStyle[] = [
    AnnouncementStyle.DANGER,
    AnnouncementStyle.WARNING,
    AnnouncementStyle.CUSTOM,
    AnnouncementStyle.SUCCESS,
];

export function pickMostSevereColor(items: { style: AnnouncementStyle; textColor?: string | null; backgroundColor?: string | null }[]): AnnouncementColors {
    for (const style of SEVERITY_ORDER) {
        const match = items.find(i => i.style === style);
        if (match) {
            return resolveAnnouncementColors(match.style, match.textColor, match.backgroundColor);
        }
    }
    return resolveAnnouncementColors(AnnouncementStyle.WARNING);
}
